import { useSelector } from "react-redux";
import { IconDispatcher } from "shared/Icons";
import GenericPopover from "shared/popovers/GenericPopover";
import styled from "styled-components";

export const JourneyMaps = ({ cjmIds}) => {
	const showSampleData = useSelector((state) => state.settings.organization?.showSampleData);
	const all_maps = useSelector((state) => state.maps.all_maps).getActiveRecords(!showSampleData,false);
	const RenderMapItem = ({ cjmId, className, showIcon = true }) => {
		const cjm = all_maps?.find((map) => map.cjmId === cjmId);
		return <WrapperMap className='d-flex align-items-center'>
			{showIcon && IconDispatcher("CJM","border border-dark rounded-circle p-1 me-2") }
			<div className={`text-truncate ${className}`}>
				{cjm?.name}

			</div>
		</WrapperMap>;
	};
	const accessCjmIds = cjmIds?.filter((cjmId) => all_maps?.find((map) => map.cjmId === cjmId));
	const MapListPopover = (
		<div className="px-3 py-1">
			{accessCjmIds?.slice(1, Infinity).map((cjm) => (
				<div key={cjm} className="mb-1">
					<RenderMapItem cjmId={cjm} className="py-1" />
				</div>
			))}
		</div>
	);

	const render = () => {
		if (accessCjmIds?.length === 0) return "-";
		if (accessCjmIds?.length === 1)
			return (
				<Container>
					<RenderMapItem cjmId={accessCjmIds[0]} className="py-1"  showIcon={false}  />
				</Container>
			);
		if (accessCjmIds?.length > 1) {
			return (
				<Container>
					<GenericPopover custom={MapListPopover}>
						<PopoerTriggerContainer>
							<RenderMapItem cjmId={accessCjmIds[0]} showIcon={false} />
							<Number>+{accessCjmIds?.length - 1}</Number>
						</PopoerTriggerContainer>
					</GenericPopover>
				</Container>
			);
		}
	};

	return render();
};

const Container = styled.div`
	display: flex;
	overflow: hidden;
`;

const WrapperMap = styled.div`
	max-width: 320px;
`;

const PopoerTriggerContainer = styled.div`
	display: flex;
	width: 100%;
`;

const Number = styled.div`
    margin-left: 4px;
`
